module.exports = __webpack_public_path__ + "img/calendario-Pre-Kinder.fe9866bf.png";